import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const CreateActivityRequestSchema = z.object({
  mediaPlanId: z.string(),
  name: z.string(),
  budget: z.string().nullable(),
  dateFrom: z.string(),
  dateTo: z.string(),
});

export const CreateActivityResponseSchema = createResponseSchema(
  z.object({
    createdBy: z.number(),
    updatedBy: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
    id: z.string(),
    name: z.string(),
    mediaPlanId: z.string(),
    budget: z.string().nullable(),
    dateFrom: z.string(),
    dateTo: z.string(),
  }),
);

export const previewActivityListResponse = createResponseSchema(
  z.object({ id: z.string(), name: z.string() }),
);

export const BudgetingLevel = z.object({
  id: z.string(),
  label: z.string(),
  levelType: z.string(),
  mdmId: z.string().nullable(),
});

export const BudgetingLevelResponseSchema =
  createResponseSchema(BudgetingLevel);

export const PlatformsResponseSchema = z.object({
  data: z.object({
    items: z.array(
      z.object({
        label: z.string(),
        name: z.string(),
      }),
    ),
  }),
});

export const ActivitySchema = z.object({
  name: z.string(),
  dateFrom: z.string(),
  dateTo: z.string(),
});

export const ActivityResponseSchema = createResponseSchema(ActivitySchema);

export const ChannelNamesQuerySchema = z.object({
  platformName: z.string().nullable().optional(),
  mediaRowItemId: z.string().nullable().optional(),
});

export const ChannelNamesResponseSchema = createResponseSchema(z.string());

export const MediaRowsQuerySchema = z.object({
  platformName: z.string().nullable().optional(),
  channelName: z.string().nullable().optional(),
});

export const MediaRowItemSchema = z.object({
  mediaItemId: z.string(),
  name: z.string(),
  channelName: z.string(),
});

export const MediaRowsResponseSchema = createResponseSchema(MediaRowItemSchema);
